<footer class="w-full">
  <nav class="footer-nav">
    <ul class="flex justify-center text-xs text-center py-2 flex-wrap">
      <li class="mx-4" *ngFor="let footerNav of footerNavigation">
        <ng-template [ngIf]="footerNav.navLink[0] === ''">
          <span [innerHTML]="footerNav.navText"></span>
        </ng-template>
        <ng-template [ngIf]="footerNav.navLink[0] !== ''">
          <ng-container *ngIf="footerNav.navLink[0].startsWith('http'); else internalLink">
            <a *ngIf="this.env.brandingKey === CustomClients.LufthansaMedialounge" [href]="footerNav.navLink">{{ footerNav.navText }}</a>
            <a *ngIf="this.env.brandingKey !== CustomClients.LufthansaMedialounge" [href]="footerNav.navLink" target="_blank">{{ footerNav.navText }}</a>
          </ng-container>
          <ng-template #internalLink>
            <a [routerLink]="footerNav.navLink" [attr.aria-current]="footerNav.navLink[0] === currentUrl || null">{{ footerNav.navText }}</a>
          </ng-template>
        </ng-template>
      </li>
    </ul>
  </nav>
</footer>
